import React from 'react';
import {AutocompleteInput} from './Inputs';
import {useFetch} from 'hooks/useFetchData';

type OptionType = {id: number; label: string};

type AutocompleteResourceInputProps = {
  resource: string;
  name: string;
  label?: string;
  multiple?: boolean;
  fullWidth?: boolean;
  required?: boolean;
};

const AutocompleteResourceInput = ({resource, ...rest}: AutocompleteResourceInputProps) => {
  const {data, loading} = useFetch<{items: {id: number; name: string}[]}>('GET_LIST', resource);
  const userOptions = React.useMemo<OptionType[]>(
    () =>
      (data?.items || [])
        .filter((item): item is {id: number; name: string} => item.id != null && item.name != null)
        .map((item) => ({id: item.id, label: item.name})),
    [data]
  );

  return <AutocompleteInput<OptionType> loading={loading} options={userOptions} {...rest} />;
};

export default AutocompleteResourceInput;
